import { component } from 'picoapp'

export default component((node, ctx) => {

  const testimonialsNode = node.querySelector('.featured-testimonials__slider');
  let flickityOptions = {
    wrapAround: true,
    pageDots: true,
    autoPlay: 4000,
    prevNextButtons: false
  };

  // if ( matchMedia('(min-width: 1200px)').matches ) { // $laptop
  //   flickityOptions.fade = true;
  //   flickityOptions.draggable = false;
  // }

  const testimonialsFlickity = new Flickity( testimonialsNode, flickityOptions );

  // call resize after the page loads to fix bug with pjax
  setTimeout(function() {
    testimonialsFlickity.resize();
  }, 500);

})
